import * as React from "react";
import {
    makeStyles,
    createStyles,
    DialogContent as MuiDialogContent,
} from "@material-ui/core";
import { Loading } from "..";
import { AreaNotification } from "../notifications";
import { RelodeTheme } from "../styles";

export type DialogContentProps = {
    id?: string;
    children?: React.ReactNode;
    isLoading?: boolean;
    notificationAreaName?: string;
};

const useDialogStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
            },
        }),
    { name: "Dialog" }
);
export const DialogContent = (props: DialogContentProps) => {
    const { children, isLoading, notificationAreaName } = props;
    const classes = useDialogStyles(props);
    let dataCy;

    if (props["data-cy"]) {
        dataCy = props["data-cy"];
    } else if (props.id) {
        dataCy = `${props.id}-content`;
    } else {
        dataCy = "dialog-content";
    }

    return (
        <MuiDialogContent data-cy={dataCy} classes={{ root: classes.root }}>
            <>
                {isLoading ? (
                    <Loading
                        isLoading={isLoading}
                        fillSpace
                        variant="blur"
                        showIndicator
                    >
                        {children}
                    </Loading>
                ) : (
                    <>{children}</>
                )}
                {!!notificationAreaName ? (
                    <DialogContent.NotificationArea
                        areaName={notificationAreaName}
                    />
                ) : null}
            </>
        </MuiDialogContent>
    );
};

const useDialogContentNotificationStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                marginTop: 24,
                marginBottom: 0,

                marginRight: 0,
                marginLeft: 0,
            },
        }),
    { name: "DialogContentNotification" }
);

type DialogContentNotificationProps = {
    areaName: string;
};

const DialogContentNotification = (props: DialogContentNotificationProps) => {
    const { areaName } = props;
    const classes = useDialogContentNotificationStyles(props);

    return <AreaNotification areaName={areaName} className={classes.root} />;
};

DialogContent.NotificationArea = DialogContentNotification;
